// Func = limiting Scope for this file
(function () {
  function resizeWindow() {}
  function scrollDown() {
    const top = window.scrollY;
    const headerEl = document.getElementById("header");
    if (top > 40) {
      headerEl.classList.add("scroll");
    } else {
      headerEl.classList.remove("scroll");
    }
  }

  equalize();
  $(".building-views__slider").slick();
  $(".building-views .pins a").click(function (event) {
    event.preventDefault();
    if ($(this).hasClass("pin-active")) {
    } else {
      const thisHref = $(this).attr("href");
      $(".building-views__content").hide();
      $(".building-views__slider").slick("unslick");
      $(thisHref).fadeIn();
      $(".building-views__slider").slick();
      $(".building-views .pins a").removeClass("pin-active");
      $(this).addClass("pin-active");
    }
  });

  // Open booking widget
  $("#js-booking-btn").click(function () {
    // container fixed full screen
    $(".header-booking").addClass("active");
    setTimeout(function () {
      $(".form-booking").addClass("show"); //container for content (align - fade)
    }, 500);
  });

  // Close booking widget
  $(document).ready(function () {
    function closeBookingWidget() {
      $(".header-booking").removeClass("active");
      $(".form-booking").removeClass("show");
    }
  
    // ADA Close widget on button click
    $("#js-booking-close").click(function () {
      closeBookingWidget();
    });
  
    // ADA Close widget by pressing "Enter" key
    $("#js-booking-close").keydown(function (event) {
      if (event.key === "Enter") {
        closeBookingWidget();
      }
    });

    $(document).keydown(function (event) {
      if (event.key === "Escape") {
        closeBookingWidget();
      }
    });
  });
  

  $(document).ready(function () {
    $("#menu-btn, .close-nav").click(function () {
      $(".content-nav").toggleClass("open");
    });

    //Call function with browser is resized.
    $(window).resize(function (event) {
      resizeWindow();
    });
    resizeWindow();

    //Acts when scroll down page.
    $(window).scroll(function (event) {
      scrollDown();
    });

    $(".scrolldown").click(function (e) {
      e.preventDefault();
      const topHeight = $(".top-content-home").height();
      $("html,body").animate(
        {
          scrollTop: topHeight,
        },
        1200
      );
    });

    // Main Nav Dropdown
    $("#primary-nav li").hover(
      function () {
        $(this).addClass("hover");
        $("ul.submenu", this).fadeIn(200);
      },
      function () {
        $(this).removeClass("hover");
        $("ul.submenu", this).fadeOut(200);
      }
    );

    //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
    let DATE_STYLE = [true];
    function calendarRange(date) {
      let d1 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckIn").val());
      let d2 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckOut").val());
      if (
        (d1 && date.getTime() == d1.getTime()) ||
        (d2 && date.getTime() == d2.getTime())
      ) {
        DATE_STYLE[1] = "highlight-top";
      } else if (date > d1 && date < d2) {
        DATE_STYLE[1] = "highlight";
      } else {
        DATE_STYLE[1] = "";
      }
      return DATE_STYLE;
    }

    //Check in and check out datepicker for booking engine
    const DATE_FORMAT =
      $("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")
        ? $("#CheckIn").data("format")
        : "yy-mm-dd";
    $("#CheckIn").datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      dateFormat: "M d    y",
      altField: "#CheckIn__alt",
      altFormat: DATE_FORMAT,
      numberOfMonths: 1,
      minDate: 0,
      //beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        let getDate = $(this).datepicker("getDate");
        let newDate = new Date(getDate.getTime());
        newDate.setDate(newDate.getDate() + 1);
        $("#CheckOut").datepicker("setDate", newDate);
        $("#CheckOut").datepicker("option", "minDate", selectedDate);
      },
    });
    $("#CheckOut").datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      dateFormat: "M d    y",
      altField: "#CheckOut__alt",
      altFormat: DATE_FORMAT,
      // changeMonth: true,
      numberOfMonths: 1,
      //beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
      },
    });

    $(".form-entry select").change(function () {
      let thisVal = $(this).val();
      let newValue = thisVal.split(",")[0];
      $(this).siblings(".select-text").text(newValue);
    });

    // Map: Return to previous page button. Change body id to match map template's name.
    $("body#map-category #content").prepend(
      '<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>'
    );
    $("body#map-category #content").prepend(
      '<a class="btn return-from-map ada-map" href="ada-map">ADA Map</a>'
    );

    /*
		$("#formRFP").on('submit', function(e) {
			$(".hide-top").slideUp();
			e.preventDefault();
		});
		*/
  });

  $(window).load(function () {});

  //vanilla JS fancybox
  if (document.getElementsByClassName("lightbox").length > 0) {
    let allLightboxes = document.getElementsByClassName("js-lightboxbtn");
    let allLightboxesLength = allLightboxes.length;

    for (let j = 0; j < allLightboxesLength; j++) {
      allLightboxes[j].addEventListener("click", function (e) {
        e.preventDefault();
        let currentTarget = this.getAttribute("href").split("#")[1];
        if (
          !document.getElementById(currentTarget).classList.contains("open")
        ) {
          document.getElementById(currentTarget).classList.add("open");
        } else {
          document.getElementById(currentTarget).classList.remove("open");
        }
      });
    }

    let allLightcloses = document.getElementsByClassName("js-lightboxclose");
    let allLightclosesLength = allLightcloses.length;

    for (let j = 0; j < allLightclosesLength; j++) {
      allLightcloses[j].addEventListener("click", function (e) {
        e.preventDefault();
        let currentTarget = this.parentElement.parentElement.id;
        if (
          !document.getElementById(currentTarget).classList.contains("open")
        ) {
          document.getElementById(currentTarget).classList.add("open");
        } else {
          document.getElementById(currentTarget).classList.remove("open");
        }
      });
    }
  }
})();

// document.addEventListener("click", (e) => {
//   if (e.path[0] == document.querySelector("#tt_popup_modal")) {
//     var theEle = document.querySelector("#tt_popup_modal");
//     theEle.remove();
//   }
// });
